import {CreateResultNode, CreateResultSummary} from "../view-model";

export const summarizeResult = (
  node: CreateResultNode
): CreateResultSummary => {
  return node.children.map(summarizeResult).reduce(
    (accumulator, summary) => ({
      created: [...accumulator.created, ...summary.created],
      operational: [...accumulator.operational, ...summary.operational],
      failed: [...accumulator.failed, ...summary.failed],
      skipped: [...accumulator.skipped, ...summary.skipped]
    }),
    {
      created: node.status === "created" ? [node] : [],
      operational: node.status === "operational" ? [node] : [],
      failed: node.status === "failed" ? [node] : [],
      skipped: node.status === "skipped" ? [node] : []
    }
  );
};
